export {default} from './js/CBBackToTop';